import { QFilterGeneric } from './QFilterGeneric'

export class QFilterWorkflowResponsible extends QFilterGeneric {
  name = "current_workflow_responsible";
  class_name = "QFilterWorkflowResponsible";
  api_name = 'current_workflow_responsible';
  chip_component = 'ChipUser';

  chip_object() {
    return {
      value: this.value,
      name: this.name,
      readable: 'Responsable actual',
      component: this.chip_component
    };
  }

}
